"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FootprintSchema = void 0;
const zod_1 = require("zod");
const DrawingWithLayers_1 = require("./DrawingWithLayers");
exports.FootprintSchema = zod_1.z.object({
    ref: zod_1.z.string(),
    name: zod_1.z.string(),
    drawings: zod_1.z.lazy(() => DrawingWithLayers_1.AnyDrawingWithLayersSchema.array()),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.any()).optional(),
});
//# sourceMappingURL=Footprint.js.map